export default __webpack_public_path__ + "static/media/curve.fbd7c84e.svg";